(function () {
  var PRICE_SELECTOR = ".m-product-card--style-4 .m-product-card__price .m-price__regular .m-price-item--regular";
  var BOX_SELECTOR = ".m-product-card--style-4 .m-product-card__price";
  var MAX_SIZE = 20;
  var MIN_SIZE = 12;

  function fits(el) {
    return el.scrollWidth <= el.clientWidth + 1;
  }

  function fitElement(el) {
    if (!el || el.clientWidth === 0) return;

    el.style.fontSize = MAX_SIZE + "px";
    if (fits(el)) {
      el.style.fontSize = "";
      return;
    }

    var low = MIN_SIZE;
    var high = MAX_SIZE;
    var best = MIN_SIZE;

    for (var i = 0; i < 8; i++) {
      var mid = (low + high) / 2;
      el.style.fontSize = mid + "px";
      if (fits(el)) {
        best = mid;
        low = mid;
      } else {
        high = mid;
      }
    }

    el.style.fontSize = best + "px";
  }

  function fitAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(PRICE_SELECTOR).forEach(fitElement);
  }

  function init() {
    var observed = new WeakSet();
    var widths = new WeakMap();
    var resizeObserver = null;

    function watch(box) {
      if (!box || observed.has(box)) return;
      observed.add(box);
      if (resizeObserver) resizeObserver.observe(box);
    }

    function fitBoxes() {
      document.querySelectorAll(BOX_SELECTOR).forEach(function (box) {
        watch(box);
        box.querySelectorAll(".m-price__regular .m-price-item--regular").forEach(fitElement);
      });
    }

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var width = Math.round(entry.contentRect.width);
          if (widths.get(entry.target) === width) return;
          widths.set(entry.target, width);
          entry.target.querySelectorAll(".m-price__regular .m-price-item--regular").forEach(fitElement);
        });
      });
    }

    fitBoxes();

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitBoxes, 120);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitBoxes);
    }

    if (window.MutationObserver && document.body) {
      var mutationTimer;
      new MutationObserver(function () {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(fitBoxes, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
